import React from "react";

const ResumoCard = ({
    titulo,
    valor,
    icone,
    cor,
    descricao,
    valorDescricao,
    progresso,
    isLoading = false,
}) => {
    return (
        <div className="bg-card rounded-xl shadow-card p-6 glow-card">
            {isLoading ? (
                <div className="animate-pulse space-y-4">
                    <div className="h-4 bg-muted rounded w-1/3"></div>
                    <div className="h-4 bg-muted rounded w-3/2"></div>
                    <div className="h-2 bg-muted rounded w-full mt-4 "></div>
                    <div className="h-2 bg-muted rounded w-full"></div>
                </div>
            ) : (
                <>
                    <div className="flex justify-between items-start h-12">
                        <div>
                            <p className="text-muted-foreground text-sm">{titulo}</p>
                            <h3 className="font-display text-xl font-bold text-foreground mt-1">{valor}</h3>
                        </div>
                        <div className={`${cor} bg-opacity-10 p-2 rounded-lg`}>
                            <i className={`${icone} ${cor.replace("bg-", "text-")} px-2`}></i>
                        </div>
                    </div>
                    <div className="mt-4">
                        <div className="flex justify-between text-sm mb-1">
                            <span className="text-muted-foreground">{descricao}</span>
                            <span className="font-medium text-foreground">{valorDescricao}</span>
                        </div>
                        <div className="progress-bar bg-muted mt-2">
                            <div
                                className={`progress-fill ${cor}`}
                                style={{ width: `${progresso}%` }}
                            ></div>
                        </div>
                    </div>
                </>
            )}
        </div>
    );
};

export default ResumoCard;